import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutFuelSurchargeOptions extends Layout {
    buttonAddSurcharge: Button;
    sourceCustomerFuelOptions: DataSource;
    tableFuelSurcharge: Table;
}
